export const PACKAGE_VERSION = '1.6.0';
//# sourceMappingURL=constants.js.map